export const LogoMark = ({ className = "h-9 w-9", variant = "light" }) => (
  <img
    src={variant === "light" ? "/images/logo-mark-white.png" : "/images/logo-mark-petrol.png"}
    alt=""
    aria-hidden="true"
    className={`${className} object-contain`}
  />
);

export const Logo = ({ dark = false, compact = false }) => (
  <span className={`flex items-center gap-3 ${dark ? "text-ink" : "text-white"}`}>
    <LogoMark
      variant={dark ? "dark" : "light"}
      className={compact ? "h-8 w-8" : "h-10 w-10"}
    />
    <span className="flex flex-col leading-none">
      <span
        className={`font-head tracking-[0.22em] ${
          compact ? "text-sm" : "text-base sm:text-lg"
        }`}
      >
        DAVID FRANK
      </span>
      {!compact && (
        <span className="mt-1.5 text-[9px] uppercase tracking-[0.34em] opacity-70">
          Leadership Psychologie
        </span>
      )}
    </span>
  </span>
);
